import React from 'react'
import { object } from 'prop-types'
import { TITULO_ENTREGA_TELA_CONCLUSAO } from '../constantsFluxosPagamento'
import { formatCEP } from '../../../utils/formatter/formatter'

const ListaResumoEndereco = ( { dadosEndereco } ) => {
  return (
    <>
      <li>
        <b>{ TITULO_ENTREGA_TELA_CONCLUSAO }</b>
      </li>
      { dadosEndereco.rua ?
        <li>
          { `${dadosEndereco.rua}` }
          { dadosEndereco.numero ? ` ${dadosEndereco.numero}` : '' }
          { dadosEndereco.complemento ?
            ` / ${dadosEndereco.complemento}` : '' }
        </li> : null}
      { dadosEndereco.bairro ? <li>{ `Bairro ${dadosEndereco.bairro}` }</li> : null}
      { dadosEndereco.cep ? <li>{ `CEP ${formatCEP( dadosEndereco.cep )}` }</li> : null}
      { dadosEndereco.cidade ?
        <li>
          { `${dadosEndereco.cidade}` }
          { dadosEndereco.uf ? ` - ${dadosEndereco.uf}` : '' }
        </li> : null}
    </>
  )
}

ListaResumoEndereco.propTypes = {
  'dadosEndereco': object.isRequired
}

export default ListaResumoEndereco
